import '../CustomerTabs.css';

interface DocumentsTabProps {
  customerId: string;
}

export const DocumentsTab = ({ customerId: _customerId }: DocumentsTabProps) => {
  return (
    <div className="tab-content-wrapper">
      <div className="info-card">
        <h3 className="info-card-title">📄 KYC Documents</h3>
        <p className="text-secondary">Document management will be implemented with Supabase Storage integration</p>
      </div>
      
      <div className="info-card">
        <h3 className="info-card-title">📊 Account Statements</h3>
        <p className="text-secondary">Statement generation and download will be available here</p>
      </div>
    </div>
  );
};

